import { ItemType } from '../items/types.js';
import { WorkstationType } from './types.js';
// All recipes in the game
export const RECIPES = [
    // ============================================================================
    // FURNACE - Smelting ores into bars
    // ============================================================================
    {
        id: 'smelt_copper_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [{ itemType: ItemType.COPPER_ORE, quantity: 1 }],
        outputs: [{ itemType: ItemType.COPPER_BAR, quantity: 1 }],
        craftTimeMs: 2500,
        skillRequired: 'metalwork',
        minSkillLevel: 0,
        xpGain: 10,
        category: 'smelting',
    },
    {
        id: 'smelt_iron_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [{ itemType: ItemType.IRON_ORE, quantity: 1 }],
        outputs: [{ itemType: ItemType.IRON_BAR, quantity: 1 }],
        craftTimeMs: 3000,
        skillRequired: 'metalwork',
        minSkillLevel: 1,
        xpGain: 12.5,
        category: 'smelting',
    },
    {
        id: 'smelt_gold_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [{ itemType: ItemType.GOLD_ORE, quantity: 1 }],
        outputs: [{ itemType: ItemType.GOLD_BAR, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'metalwork',
        minSkillLevel: 3,
        xpGain: 22.5,
        category: 'smelting',
    },
    {
        id: 'smelt_steel_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [
            { itemType: ItemType.IRON_ORE, quantity: 1 },
            { itemType: ItemType.COAL, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.STEEL_BAR, quantity: 1 }],
        craftTimeMs: 5000,
        skillRequired: 'metalwork',
        minSkillLevel: 4,
        xpGain: 17.5,
        category: 'smelting',
    },
    {
        id: 'smelt_tin_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [{ itemType: ItemType.TIN_ORE, quantity: 1 }],
        outputs: [{ itemType: ItemType.TIN_BAR, quantity: 1 }],
        craftTimeMs: 2000,
        skillRequired: 'metalwork',
        minSkillLevel: 0,
        xpGain: 8,
        category: 'smelting',
    },
    {
        id: 'smelt_bronze_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [
            { itemType: ItemType.TIN_ORE, quantity: 1 },
            { itemType: ItemType.COPPER_ORE, quantity: 1 },
        ],
        outputs: [{ itemType: ItemType.BRONZE_BAR, quantity: 2 }],
        craftTimeMs: 3000,
        skillRequired: 'metalwork',
        minSkillLevel: 1,
        xpGain: 15,
        category: 'smelting',
    },
    {
        id: 'smelt_silver_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [{ itemType: ItemType.SILVER_ORE, quantity: 1 }],
        outputs: [{ itemType: ItemType.SILVER_BAR, quantity: 1 }],
        craftTimeMs: 4500,
        skillRequired: 'metalwork',
        minSkillLevel: 5,
        xpGain: 30,
        category: 'smelting',
    },
    {
        id: 'smelt_mithril_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [
            { itemType: ItemType.MITHRIL_ORE, quantity: 1 },
            { itemType: ItemType.COAL, quantity: 4 },
        ],
        outputs: [{ itemType: ItemType.MITHRIL_BAR, quantity: 1 }],
        craftTimeMs: 8000,
        skillRequired: 'metalwork',
        minSkillLevel: 8,
        xpGain: 75,
        category: 'smelting',
    },
    {
        id: 'smelt_starmetal_bar',
        workstationType: WorkstationType.FURNACE,
        ingredients: [
            { itemType: ItemType.STARMETAL_ORE, quantity: 1 },
            { itemType: ItemType.MITHRIL_BAR, quantity: 1 },
            { itemType: ItemType.COAL, quantity: 8 },
        ],
        outputs: [{ itemType: ItemType.STARMETAL_BAR, quantity: 1 }],
        craftTimeMs: 12000,
        skillRequired: 'metalwork',
        minSkillLevel: 12,
        xpGain: 125,
        category: 'smelting',
    },
    // ============================================================================
    // ANVIL - Smithing weapons and tools from bars
    // ============================================================================
    {
        id: 'smith_wooden_pickaxe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [],
        outputs: [{ itemType: ItemType.WOODEN_PICKAXE, quantity: 1 }],
        craftTimeMs: 1000,
        skillRequired: 'metalwork',
        minSkillLevel: 0,
        xpGain: 0,
        category: 'tools',
    },
    {
        id: 'smith_iron_sword',
        workstationType: WorkstationType.ANVIL,
        ingredients: [{ itemType: ItemType.IRON_BAR, quantity: 2 }],
        outputs: [{ itemType: ItemType.IRON_SWORD, quantity: 1 }],
        craftTimeMs: 6000,
        skillRequired: 'metalwork',
        minSkillLevel: 2,
        xpGain: 25,
        category: 'weapons',
    },
    {
        id: 'smith_iron_axe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [{ itemType: ItemType.IRON_BAR, quantity: 1 }],
        outputs: [{ itemType: ItemType.IRON_AXE, quantity: 1 }],
        craftTimeMs: 5000,
        skillRequired: 'metalwork',
        minSkillLevel: 1,
        xpGain: 20,
        category: 'tools',
    },
    {
        id: 'smith_iron_pickaxe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [{ itemType: ItemType.IRON_BAR, quantity: 2 }],
        outputs: [{ itemType: ItemType.IRON_PICKAXE, quantity: 1 }],
        craftTimeMs: 6000,
        skillRequired: 'metalwork',
        minSkillLevel: 2,
        xpGain: 25,
        category: 'tools',
    },
    {
        id: 'smith_bronze_pickaxe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.BRONZE_BAR, quantity: 2 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.BRONZE_PICKAXE, quantity: 1 }],
        craftTimeMs: 5000,
        skillRequired: 'metalwork',
        minSkillLevel: 1,
        xpGain: 20,
        category: 'tools',
    },
    {
        id: 'smith_bronze_axe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.BRONZE_BAR, quantity: 2 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.BRONZE_AXE, quantity: 1 }],
        craftTimeMs: 5000,
        skillRequired: 'metalwork',
        minSkillLevel: 1,
        xpGain: 20,
        category: 'tools',
    },
    {
        id: 'smith_steel_pickaxe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.STEEL_BAR, quantity: 3 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.STEEL_PICKAXE, quantity: 1 }],
        craftTimeMs: 7000,
        skillRequired: 'metalwork',
        minSkillLevel: 4,
        xpGain: 35,
        category: 'tools',
    },
    {
        id: 'smith_steel_axe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.STEEL_BAR, quantity: 2 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.STEEL_AXE, quantity: 1 }],
        craftTimeMs: 6000,
        skillRequired: 'metalwork',
        minSkillLevel: 4,
        xpGain: 30,
        category: 'tools',
    },
    {
        id: 'smith_silver_pickaxe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.SILVER_BAR, quantity: 3 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.SILVER_PICKAXE, quantity: 1 }],
        craftTimeMs: 8000,
        skillRequired: 'metalwork',
        minSkillLevel: 6,
        xpGain: 45,
        category: 'tools',
    },
    {
        id: 'smith_mithril_pickaxe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.MITHRIL_BAR, quantity: 4 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.MITHRIL_PICKAXE, quantity: 1 }],
        craftTimeMs: 10000,
        skillRequired: 'metalwork',
        minSkillLevel: 9,
        xpGain: 100,
        category: 'tools',
    },
    {
        id: 'smith_mithril_axe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.MITHRIL_BAR, quantity: 3 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.MITHRIL_AXE, quantity: 1 }],
        craftTimeMs: 9000,
        skillRequired: 'metalwork',
        minSkillLevel: 9,
        xpGain: 85,
        category: 'tools',
    },
    {
        id: 'smith_starmetal_pickaxe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.STARMETAL_BAR, quantity: 5 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.STARMETAL_PICKAXE, quantity: 1 }],
        craftTimeMs: 15000,
        skillRequired: 'metalwork',
        minSkillLevel: 13,
        xpGain: 175,
        category: 'tools',
    },
    {
        id: 'smith_starmetal_axe',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.STARMETAL_BAR, quantity: 4 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.STARMETAL_AXE, quantity: 1 }],
        craftTimeMs: 13000,
        skillRequired: 'metalwork',
        minSkillLevel: 13,
        xpGain: 150,
        category: 'tools',
    },
    // ============================================================================
    // ANVIL - Fishing rods (iron/steel)
    // ============================================================================
    {
        id: 'smith_iron_fishing_rod',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.IRON_BAR, quantity: 3 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.IRON_FISHING_ROD, quantity: 1 }],
        craftTimeMs: 6000,
        skillRequired: 'metalwork',
        minSkillLevel: 2,
        xpGain: 30,
        category: 'tools',
    },
    {
        id: 'smith_steel_fishing_rod',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.STEEL_BAR, quantity: 3 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.STEEL_FISHING_ROD, quantity: 1 }],
        craftTimeMs: 8000,
        skillRequired: 'metalwork',
        minSkillLevel: 4,
        xpGain: 45,
        category: 'tools',
    },
    // ============================================================================
    // CRAFTING TABLE - General crafting, wooden items
    // ============================================================================
    {
        id: 'craft_plank',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [{ itemType: ItemType.WOOD, quantity: 2 }],
        outputs: [{ itemType: ItemType.PLANK, quantity: 1 }],
        craftTimeMs: 1500,
        skillRequired: 'construction',
        minSkillLevel: 0,
        xpGain: 5,
        category: 'materials',
    },
    {
        id: 'craft_wooden_axe',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [{ itemType: ItemType.WOOD, quantity: 5 }],
        outputs: [{ itemType: ItemType.WOODEN_AXE, quantity: 1 }],
        craftTimeMs: 3000,
        skillRequired: 'construction',
        minSkillLevel: 0,
        xpGain: 10,
        category: 'tools',
    },
    {
        id: 'craft_wooden_pickaxe',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [{ itemType: ItemType.WOOD, quantity: 5 }],
        outputs: [{ itemType: ItemType.WOODEN_PICKAXE, quantity: 1 }],
        craftTimeMs: 3000,
        skillRequired: 'construction',
        minSkillLevel: 0,
        xpGain: 10,
        category: 'tools',
    },
    {
        id: 'craft_wooden_sword',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [{ itemType: ItemType.WOOD, quantity: 4 }],
        outputs: [{ itemType: ItemType.WOODEN_SWORD, quantity: 1 }],
        craftTimeMs: 2500,
        skillRequired: 'construction',
        minSkillLevel: 0,
        xpGain: 8,
        category: 'weapons',
    },
    {
        id: 'craft_stone_axe',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 3 },
            { itemType: ItemType.STONE, quantity: 5 },
        ],
        outputs: [{ itemType: ItemType.STONE_AXE, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'construction',
        minSkillLevel: 1,
        xpGain: 15,
        category: 'tools',
    },
    {
        id: 'craft_stone_pickaxe',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 3 },
            { itemType: ItemType.STONE, quantity: 5 },
        ],
        outputs: [{ itemType: ItemType.STONE_PICKAXE, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'construction',
        minSkillLevel: 1,
        xpGain: 15,
        category: 'tools',
    },
    {
        id: 'craft_stone_sword',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 2 },
            { itemType: ItemType.STONE, quantity: 4 },
        ],
        outputs: [{ itemType: ItemType.STONE_SWORD, quantity: 1 }],
        craftTimeMs: 3500,
        skillRequired: 'construction',
        minSkillLevel: 1,
        xpGain: 12,
        category: 'weapons',
    },
    // ============================================================================
    // CAMPFIRE - Basic cooking
    // ============================================================================
    {
        id: 'cook_meat_campfire',
        workstationType: WorkstationType.CAMPFIRE,
        ingredients: [{ itemType: ItemType.RAW_MEAT, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_MEAT, quantity: 1 }],
        craftTimeMs: 2000,
        skillRequired: 'cooking',
        minSkillLevel: 0,
        xpGain: 15,
        category: 'cooking',
    },
    // ============================================================================
    // COOKING STOVE - Advanced cooking
    // ============================================================================
    {
        id: 'cook_meat_stove',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [{ itemType: ItemType.RAW_MEAT, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_MEAT, quantity: 1 }],
        craftTimeMs: 1500,
        skillRequired: 'cooking',
        minSkillLevel: 0,
        xpGain: 12,
        category: 'cooking',
    },
    {
        id: 'bake_bread',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [{ itemType: ItemType.BERRIES, quantity: 5 }],
        outputs: [{ itemType: ItemType.BREAD, quantity: 1 }],
        craftTimeMs: 3000,
        skillRequired: 'cooking',
        minSkillLevel: 2,
        xpGain: 20,
        category: 'cooking',
    },
    // ============================================================================
    // CAMPFIRE - Fish cooking
    // ============================================================================
    {
        id: 'cook_minnow_campfire',
        workstationType: WorkstationType.CAMPFIRE,
        ingredients: [{ itemType: ItemType.RAW_MINNOW, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_MINNOW, quantity: 1 }],
        craftTimeMs: 1500,
        skillRequired: 'cooking',
        minSkillLevel: 0,
        xpGain: 10,
        category: 'cooking',
    },
    {
        id: 'cook_shrimp_campfire',
        workstationType: WorkstationType.CAMPFIRE,
        ingredients: [{ itemType: ItemType.RAW_SHRIMP, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_SHRIMP, quantity: 1 }],
        craftTimeMs: 2000,
        skillRequired: 'cooking',
        minSkillLevel: 6,
        xpGain: 25,
        category: 'cooking',
    },
    {
        id: 'cook_trout_campfire',
        workstationType: WorkstationType.CAMPFIRE,
        ingredients: [{ itemType: ItemType.RAW_TROUT, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_TROUT, quantity: 1 }],
        craftTimeMs: 2000,
        skillRequired: 'cooking',
        minSkillLevel: 3,
        xpGain: 20,
        category: 'cooking',
    },
    {
        id: 'cook_cod_campfire',
        workstationType: WorkstationType.CAMPFIRE,
        ingredients: [{ itemType: ItemType.RAW_COD, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_COD, quantity: 1 }],
        craftTimeMs: 2000,
        skillRequired: 'cooking',
        minSkillLevel: 5,
        xpGain: 30,
        category: 'cooking',
    },
    {
        id: 'cook_salmon_campfire',
        workstationType: WorkstationType.CAMPFIRE,
        ingredients: [{ itemType: ItemType.RAW_SALMON, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_SALMON, quantity: 1 }],
        craftTimeMs: 2500,
        skillRequired: 'cooking',
        minSkillLevel: 8,
        xpGain: 40,
        category: 'cooking',
    },
    {
        id: 'cook_eel_campfire',
        workstationType: WorkstationType.CAMPFIRE,
        ingredients: [{ itemType: ItemType.RAW_SWAMP_EEL, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_EEL, quantity: 1 }],
        craftTimeMs: 3000,
        skillRequired: 'cooking',
        minSkillLevel: 12,
        xpGain: 50,
        category: 'cooking',
    },
    // ============================================================================
    // COOKING STOVE - Fish cooking (faster)
    // ============================================================================
    {
        id: 'cook_minnow_stove',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [{ itemType: ItemType.RAW_MINNOW, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_MINNOW, quantity: 1 }],
        craftTimeMs: 1000,
        skillRequired: 'cooking',
        minSkillLevel: 0,
        xpGain: 8,
        category: 'cooking',
    },
    {
        id: 'cook_shrimp_stove',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [{ itemType: ItemType.RAW_SHRIMP, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_SHRIMP, quantity: 1 }],
        craftTimeMs: 1500,
        skillRequired: 'cooking',
        minSkillLevel: 6,
        xpGain: 20,
        category: 'cooking',
    },
    {
        id: 'cook_trout_stove',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [{ itemType: ItemType.RAW_TROUT, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_TROUT, quantity: 1 }],
        craftTimeMs: 1500,
        skillRequired: 'cooking',
        minSkillLevel: 3,
        xpGain: 16,
        category: 'cooking',
    },
    {
        id: 'cook_cod_stove',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [{ itemType: ItemType.RAW_COD, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_COD, quantity: 1 }],
        craftTimeMs: 1500,
        skillRequired: 'cooking',
        minSkillLevel: 5,
        xpGain: 24,
        category: 'cooking',
    },
    {
        id: 'cook_salmon_stove',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [{ itemType: ItemType.RAW_SALMON, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_SALMON, quantity: 1 }],
        craftTimeMs: 2000,
        skillRequired: 'cooking',
        minSkillLevel: 8,
        xpGain: 32,
        category: 'cooking',
    },
    {
        id: 'cook_eel_stove',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [{ itemType: ItemType.RAW_SWAMP_EEL, quantity: 1 }],
        outputs: [{ itemType: ItemType.COOKED_EEL, quantity: 1 }],
        craftTimeMs: 2500,
        skillRequired: 'cooking',
        minSkillLevel: 12,
        xpGain: 40,
        category: 'cooking',
    },
    // Fish stew variants (cooking stove only)
    {
        id: 'fish_stew_minnow',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [
            { itemType: ItemType.COOKED_MINNOW, quantity: 2 },
            { itemType: ItemType.BERRIES, quantity: 1 },
        ],
        outputs: [{ itemType: ItemType.FISH_STEW, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'cooking',
        minSkillLevel: 15,
        xpGain: 80,
        category: 'cooking',
    },
    {
        id: 'fish_stew_shrimp',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [
            { itemType: ItemType.COOKED_SHRIMP, quantity: 2 },
            { itemType: ItemType.BERRIES, quantity: 1 },
        ],
        outputs: [{ itemType: ItemType.FISH_STEW, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'cooking',
        minSkillLevel: 15,
        xpGain: 80,
        category: 'cooking',
    },
    {
        id: 'fish_stew_trout',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [
            { itemType: ItemType.COOKED_TROUT, quantity: 2 },
            { itemType: ItemType.BERRIES, quantity: 1 },
        ],
        outputs: [{ itemType: ItemType.FISH_STEW, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'cooking',
        minSkillLevel: 15,
        xpGain: 80,
        category: 'cooking',
    },
    {
        id: 'fish_stew_cod',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [
            { itemType: ItemType.COOKED_COD, quantity: 2 },
            { itemType: ItemType.BERRIES, quantity: 1 },
        ],
        outputs: [{ itemType: ItemType.FISH_STEW, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'cooking',
        minSkillLevel: 15,
        xpGain: 80,
        category: 'cooking',
    },
    {
        id: 'fish_stew_salmon',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [
            { itemType: ItemType.COOKED_SALMON, quantity: 2 },
            { itemType: ItemType.BERRIES, quantity: 1 },
        ],
        outputs: [{ itemType: ItemType.FISH_STEW, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'cooking',
        minSkillLevel: 15,
        xpGain: 80,
        category: 'cooking',
    },
    {
        id: 'fish_stew_eel',
        workstationType: WorkstationType.COOKING_STOVE,
        ingredients: [
            { itemType: ItemType.COOKED_EEL, quantity: 2 },
            { itemType: ItemType.BERRIES, quantity: 1 },
        ],
        outputs: [{ itemType: ItemType.FISH_STEW, quantity: 1 }],
        craftTimeMs: 4000,
        skillRequired: 'cooking',
        minSkillLevel: 15,
        xpGain: 80,
        category: 'cooking',
    },
    // ============================================================================
    // CRAFTING TABLE - Fishing rods (wood/copper)
    // ============================================================================
    {
        id: 'craft_wooden_fishing_rod',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [{ itemType: ItemType.WOOD, quantity: 5 }],
        outputs: [{ itemType: ItemType.WOODEN_FISHING_ROD, quantity: 1 }],
        craftTimeMs: 3000,
        skillRequired: 'construction',
        minSkillLevel: 0,
        xpGain: 10,
        category: 'tools',
    },
    {
        id: 'craft_copper_fishing_rod',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [
            { itemType: ItemType.COPPER_BAR, quantity: 3 },
            { itemType: ItemType.WOOD, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.COPPER_FISHING_ROD, quantity: 1 }],
        craftTimeMs: 5000,
        skillRequired: 'metalwork',
        minSkillLevel: 5,
        xpGain: 20,
        category: 'tools',
    },
    // ============================================================================
    // CRAFTING TABLE - Bows (wood/stone)
    // ============================================================================
    {
        id: 'craft_wooden_bow',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [{ itemType: ItemType.WOOD, quantity: 8 }],
        outputs: [{ itemType: ItemType.WOODEN_BOW, quantity: 1 }],
        craftTimeMs: 5000,
        skillRequired: 'construction',
        minSkillLevel: 1,
        xpGain: 20,
        category: 'ranged',
    },
    {
        id: 'craft_stone_bow',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 6 },
            { itemType: ItemType.STONE, quantity: 4 },
        ],
        outputs: [{ itemType: ItemType.STONE_BOW, quantity: 1 }],
        craftTimeMs: 6000,
        skillRequired: 'construction',
        minSkillLevel: 2,
        xpGain: 25,
        category: 'ranged',
    },
    // ============================================================================
    // CRAFTING TABLE - Arrows (wood/stone)
    // ============================================================================
    {
        id: 'craft_wooden_arrows',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [{ itemType: ItemType.WOOD, quantity: 5 }],
        outputs: [{ itemType: ItemType.WOODEN_ARROW, quantity: 20 }],
        craftTimeMs: 3000,
        skillRequired: 'construction',
        minSkillLevel: 0,
        xpGain: 10,
        category: 'ammunition',
    },
    {
        id: 'craft_stone_arrows',
        workstationType: WorkstationType.CRAFTING_TABLE,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 3 },
            { itemType: ItemType.STONE, quantity: 4 },
        ],
        outputs: [{ itemType: ItemType.STONE_ARROW, quantity: 15 }],
        craftTimeMs: 4000,
        skillRequired: 'construction',
        minSkillLevel: 1,
        xpGain: 15,
        category: 'ammunition',
    },
    // ============================================================================
    // ANVIL - Metal Bows
    // ============================================================================
    {
        id: 'smith_iron_bow',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 4 },
            { itemType: ItemType.IRON_BAR, quantity: 3 },
        ],
        outputs: [{ itemType: ItemType.IRON_BOW, quantity: 1 }],
        craftTimeMs: 8000,
        skillRequired: 'metalwork',
        minSkillLevel: 2,
        xpGain: 30,
        category: 'ranged',
    },
    {
        id: 'smith_bronze_bow',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 4 },
            { itemType: ItemType.BRONZE_BAR, quantity: 3 },
        ],
        outputs: [{ itemType: ItemType.BRONZE_BOW, quantity: 1 }],
        craftTimeMs: 7000,
        skillRequired: 'metalwork',
        minSkillLevel: 3,
        xpGain: 35,
        category: 'ranged',
    },
    {
        id: 'smith_steel_bow',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 4 },
            { itemType: ItemType.STEEL_BAR, quantity: 3 },
        ],
        outputs: [{ itemType: ItemType.STEEL_BOW, quantity: 1 }],
        craftTimeMs: 9000,
        skillRequired: 'metalwork',
        minSkillLevel: 4,
        xpGain: 40,
        category: 'ranged',
    },
    {
        id: 'smith_silver_bow',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 4 },
            { itemType: ItemType.SILVER_BAR, quantity: 3 },
        ],
        outputs: [{ itemType: ItemType.SILVER_BOW, quantity: 1 }],
        craftTimeMs: 10000,
        skillRequired: 'metalwork',
        minSkillLevel: 5,
        xpGain: 50,
        category: 'ranged',
    },
    {
        id: 'smith_mithril_bow',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 4 },
            { itemType: ItemType.MITHRIL_BAR, quantity: 3 },
        ],
        outputs: [{ itemType: ItemType.MITHRIL_BOW, quantity: 1 }],
        craftTimeMs: 12000,
        skillRequired: 'metalwork',
        minSkillLevel: 6,
        xpGain: 70,
        category: 'ranged',
    },
    {
        id: 'smith_starmetal_bow',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 4 },
            { itemType: ItemType.STARMETAL_BAR, quantity: 3 },
        ],
        outputs: [{ itemType: ItemType.STARMETAL_BOW, quantity: 1 }],
        craftTimeMs: 15000,
        skillRequired: 'metalwork',
        minSkillLevel: 7,
        xpGain: 100,
        category: 'ranged',
    },
    // ============================================================================
    // ANVIL - Metal Arrows
    // ============================================================================
    {
        id: 'smith_iron_arrows',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 2 },
            { itemType: ItemType.IRON_BAR, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.IRON_ARROW, quantity: 15 }],
        craftTimeMs: 5000,
        skillRequired: 'metalwork',
        minSkillLevel: 2,
        xpGain: 20,
        category: 'ammunition',
    },
    {
        id: 'smith_bronze_arrows',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 2 },
            { itemType: ItemType.BRONZE_BAR, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.BRONZE_ARROW, quantity: 15 }],
        craftTimeMs: 4500,
        skillRequired: 'metalwork',
        minSkillLevel: 3,
        xpGain: 22,
        category: 'ammunition',
    },
    {
        id: 'smith_steel_arrows',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 2 },
            { itemType: ItemType.STEEL_BAR, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.STEEL_ARROW, quantity: 15 }],
        craftTimeMs: 5500,
        skillRequired: 'metalwork',
        minSkillLevel: 4,
        xpGain: 25,
        category: 'ammunition',
    },
    {
        id: 'smith_silver_arrows',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 2 },
            { itemType: ItemType.SILVER_BAR, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.SILVER_ARROW, quantity: 10 }],
        craftTimeMs: 6000,
        skillRequired: 'metalwork',
        minSkillLevel: 5,
        xpGain: 30,
        category: 'ammunition',
    },
    {
        id: 'smith_mithril_arrows',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 2 },
            { itemType: ItemType.MITHRIL_BAR, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.MITHRIL_ARROW, quantity: 10 }],
        craftTimeMs: 7000,
        skillRequired: 'metalwork',
        minSkillLevel: 6,
        xpGain: 40,
        category: 'ammunition',
    },
    {
        id: 'smith_starmetal_arrows',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.WOOD, quantity: 2 },
            { itemType: ItemType.STARMETAL_BAR, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.STARMETAL_ARROW, quantity: 10 }],
        craftTimeMs: 8000,
        skillRequired: 'metalwork',
        minSkillLevel: 7,
        xpGain: 55,
        category: 'ammunition',
    },
    // ============================================================================
    // ANVIL - Flintlock Pistol and Ammunition
    // ============================================================================
    {
        id: 'smith_flintlock_pistol',
        workstationType: WorkstationType.ANVIL,
        ingredients: [
            { itemType: ItemType.IRON_BAR, quantity: 5 },
            { itemType: ItemType.WOOD, quantity: 2 },
            { itemType: ItemType.COPPER_BAR, quantity: 1 },
        ],
        outputs: [{ itemType: ItemType.FLINTLOCK_PISTOL, quantity: 1 }],
        craftTimeMs: 15000,
        skillRequired: 'metalwork',
        minSkillLevel: 4,
        xpGain: 60,
        category: 'ranged',
    },
    {
        id: 'smith_lead_balls',
        workstationType: WorkstationType.ANVIL,
        ingredients: [{ itemType: ItemType.IRON_BAR, quantity: 2 }],
        outputs: [{ itemType: ItemType.LEAD_BALL, quantity: 15 }],
        craftTimeMs: 4000,
        skillRequired: 'metalwork',
        minSkillLevel: 2,
        xpGain: 15,
        category: 'ammunition',
    },
    // ============================================================================
    // FURNACE - Gunpowder
    // ============================================================================
    {
        id: 'make_gunpowder',
        workstationType: WorkstationType.FURNACE,
        ingredients: [
            { itemType: ItemType.COAL, quantity: 5 },
            { itemType: ItemType.STONE, quantity: 2 },
        ],
        outputs: [{ itemType: ItemType.GUNPOWDER, quantity: 10 }],
        craftTimeMs: 5000,
        skillRequired: 'metalwork',
        minSkillLevel: 3,
        xpGain: 25,
        category: 'smelting',
    },
];
// Build recipe lookup map
const RECIPE_MAP = new Map();
for (const recipe of RECIPES) {
    RECIPE_MAP.set(recipe.id, recipe);
}
// Get recipe by ID
export const getRecipeById = ({ recipeId }) => {
    return RECIPE_MAP.get(recipeId) ?? null;
};
// Get all recipes for a workstation type
export const getRecipesForWorkstation = ({ workstationType, }) => {
    return RECIPES.filter((r) => r.workstationType === workstationType);
};
// Get recipes for a workstation filtered by category
export const getRecipesByCategory = ({ workstationType, category, }) => {
    return RECIPES.filter((r) => r.workstationType === workstationType && r.category === category);
};
// Get all unique categories for a workstation
export const getWorkstationCategories = ({ workstationType, }) => {
    const categories = new Set();
    for (const recipe of RECIPES) {
        if (recipe.workstationType === workstationType) {
            categories.add(recipe.category);
        }
    }
    return Array.from(categories);
};
// Check if a recipe exists
export const recipeExists = ({ recipeId }) => {
    return RECIPE_MAP.has(recipeId);
};
//# sourceMappingURL=recipes.js.map